import { UserInfo } from './user-info.model';
import { Group } from './group.model';
import { Authority } from './authority.model';

export const NOT_ADMIN_PERMISSION = 'not_admin';

export const RESET_PASSWORD_TOKEN = 'otp';

export class AuthUser {
    id: number;
    userId: number;
    username: string;
    email: string;
    token?: string;
    groups: Group[];
    authorities: Authority[];
    userInfo: UserInfo;

    hasGroup(groupCode: string) {
        return this.groups && !!this.groups.find(group => group.code === groupCode);
    }
    hasRole(role: string) {
        return this.authorities && !!this.authorities.find(auth => auth.authority === `ROLE_${role}`);
    }
    hasPermission(permission: string) {
        return this.authorities && !!this.authorities.find(auth => auth.authority === permission);
    }
    isAdmin() {
        return this.authorities && !!this.authorities.find(auth => auth.authority === 'ROLE_admin');
    }
}
